export enum Browser {
  Firefox = 'firefox',
  Chrome = 'chrome',
  Safari = 'safari',
  Edge = 'msedge',
  Opera = 'opera',
  IE = 'msie',
  SamsungBrowser = 'samsungBrowser',
  Chromium = 'chromium',
}

export enum BrowserType {
  Desktop = 'desktop',
  Tablet = 'tablet',
  Mobile = 'mobile',
}

export enum OS {
  Linux = 'linux',
  MacOS = 'mac',
  Windows = 'windows',
  IOS = 'ios',
  Android = 'android',
  ChromeOS = 'chromeos',
}

export type SystemInfo = {
  os: OS | string;
  osVersion: string;
  browser: Browser | string;
  browserVersion: string;
  deviceType: BrowserType;
};
